/** Synthetic storefront product ids (not tied to RAW_PRODUCTS line index). */
export const SPOTIFY_1M_SHARED_PRODUCT_ID = 136 as const
